import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import imagArray from "./Images";

const Services = () => {
  const technologies = [
    { key: "html-logo.png", alt: "HTML" },
    { key: "css3-logo.png", alt: "CSS" },
    { key: "bootstrap-logo.png", alt: "Bootstrap" },
    { key: "react-logo.png", alt: "React" },
    { key: "javascript-logo.png", alt: "JavaScript" },
    { key: "logos/typescript-logo.png", alt: "TypeScript" },
    { key: "logos/nextjs-logo.png", alt: "Next.js" },
    { key: "logos/tailwindcss-logo.png", alt: "Tailwind CSS" },
    { key: "Sass_Logo.png", alt: "Sass" },
    { key: "AngularJS.png", alt: "AngularJS" },
    { key: "jquery.png", alt: "JQuery" },
    { key: "python-logo.png", alt: "Python" },
    { key: "java-logo.png", alt: "Java" },
    { key: "CPlus-logo.png", alt: "C++" },
    { key: "php-logo-1.png", alt: "Php" },
    { key: "logos/spring-boot-logo.png", alt: "Spring Boot" },
    { key: "django.png", alt: "Django" },
    { key: "nodejs-logo.png", alt: "Node JS" },
    { key: "mongodb-logo.png", alt: "MongoDB" },
    { key: "postgresql-logo.png", alt: "Postgresql" },
    { key: "mysql-logo-1.png", alt: "MySQL" },
    { key: "oracle-logo.png", alt: "Oracle" },
  ];

  return (
    <>
      <div className="intro-header">
        <div className="container-fluid ">
          <div className="intro-message d-flex justify-content-end align-items-center ">
            <h1>SOFTWARE DEVELOPMENT SERVICES</h1>
          </div>
        </div>
      </div>
      <Container>
        <h3 className="section-heading mt-5">Services</h3>
        <hr />
        <Row className="justify-content-center mb-3 py-3" id="firstrow">
          <Col className="mb-3" lg={6}>
            <Card>
              <Card.Img
                className="img-responsive w-75 mt-2"
                src={imagArray["Fullstack1.png"]}
                height="200"
              />
              <Card.Body>
                <Card.Title>Full Stack Development</Card.Title>
                <Card.Text className="text-justify">
                  Software development across a full range of technologies, from
                  front-end prototyping to a complete set of back-end services.
                  <ul>
                    <li>Single Page Application</li>
                    <li>Responsive Web Applications</li>
                    <li>Customized Software Solutions</li>
                    <li>API Development</li>
                    <li>Application Maintenance</li>
                  </ul>
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col className="mb-3" lg={6}>
            <Card>
              <Card.Img
                className="img-responsive w-75 mt-2"
                src={imagArray["Responsive.png"]}
                height="200"
              />
              <Card.Body>
                <Card.Title>Responsive-Design</Card.Title>
                <Card.Text className="text-justify">
                  Responsive design is a graphic user interface (GUI) design
                  approach used to create content that adjusts smoothly to
                  various screen sizes. We create user-friendly and responsive
                  Websites suitable for multiple Media devices such as:
                  <ul>
                    <li>Smartphones</li>
                    <li>Tablets</li>
                    <li>Desktops</li>
                  </ul>
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col className="mb-3" lg={6}>
            <Card>
              <Card.Img
                className="img-responsive w-75 mt-2"
                src={imagArray["Ecommerce.jpg"]}
                height="200"
              />
              <Card.Body>
                <Card.Title>E-commerce Solutions</Card.Title>
                <Card.Text className="text-justify">
                  We provide e-commerce software development services for small
                  to medium range Enterprises.
                  <ul>
                    <li>Custom Web Portals</li>
                    <li>Shopping Carts</li>
                    <li>Mobile Applications</li>
                    <li>Payment Gateway</li>
                  </ul>
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col className="mb-3" lg={6}>
            <Card>
              <Card.Img
                className="img-responsive w-75 mt-2"
                src={imagArray["BI.jpg"]}
                height="200"
              />
              <Card.Body>
                <Card.Title>BI Analytics & Data Science Services</Card.Title>
                <Card.Text className="text-justify">
                  We develop statistical, machine learning and AI models for our
                  customers to improve products, services and processes.
                  <ul>
                    <li>Business Intelligence Reports</li>
                    <li>Interactive Dashboards</li>
                    <li>AI-driven Analytics</li>
                    <li>Developing Machine Learning Models</li>
                    <li>Data Models & Visualization</li>
                  </ul>
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      <Container className="key-technology">
        <h3 className="section-heading mb-0">Key Technologies</h3>
        <hr />
        <div className="tech-grid mb-4">
          {technologies.map((tech) => (
            <div className="tech-tile" key={tech.key}>
              <img src={imagArray[tech.key]} className="img-thumbnail" alt={tech.alt} />
            </div>
          ))}
        </div>
      </Container>      
    </>
  );
};

export default Services;
